<template>
  <div :class="{'min-width-907' : bp == 'lg' || bp == 'xl'}">
       <b-form-group
          label-for="busy-textarea"
          class="mb-3"
        >
            <template slot="label">
                <div class="d-flex justify-content-between">
                    <div>Busy Message:</div>
                    <b-icon 
                        class="cursor-pointer" 
                        v-b-popover.hover.top="'The message which will be converted into speech that will play to the caller if no agent picks up the call before they hear a beep and their voicemail recorded.'" 
                        icon="question-circle">
                    </b-icon>
                </div>
            </template>
          <b-form-textarea
            id="busy-textarea"
            v-model="busyMessage"
            :disabled="generatingAudio || playingAudio"
            @input="audioStream = null"
            rows="3"
            required
          ></b-form-textarea>
          <div class="d-flex justify-content-end">
            
            <b-button v-if="!playingAudio && (!audioStream || !isLatestGeneratedText(busyMessage))" :disabled="generatingAudio" size="sm" class="mt-1 mr-1" @click="generateTextToSpeech(busyMessage)">
                <b-icon icon="volume-up"></b-icon> {{generatingAudio ? 'Generating Audio...' : 'Play Audio Preview'}}
            </b-button>

            <b-button v-else size="sm" :disabled="busyMessageDisabled" class="mt-1 mr-1" @click="playStopAudioStream('busyMessage')">
                <b-icon icon="volume-up"></b-icon> {{playingAudio ? 'Stop Audio' : 'Play Audio Preview'}}
            </b-button>

            <b-button 
                @click="defaultMessageConfirm('busyMessage')" 
                :disabled="playingAudio"
                class="mt-1 mr-1" 
                size="sm"
            >Use Default Message</b-button>

             <b-button variant="primary" 
                :disabled="dbMessages.busyMessage == busyMessage"
                @click="saveMessageConfirm('busyMessage')" 
                class="mt-1" size="sm">{{ dbMessages.busyMessage == busyMessage ? 'Saved' : 'Save' }}</b-button>
          </div>
        </b-form-group>

        <b-form-group
          label-for="out-of-office-textarea"
          class="mb-3"
        >
            <template slot="label">
                <div class="d-flex justify-content-between">
                    <div>Out Of Office Message:</div>
                    <b-icon 
                        class="cursor-pointer" 
                        v-b-popover.hover.top="'The message which will be converted into speech that will play to the caller calling outside of office hours.'" 
                        icon="question-circle">
                    </b-icon>
                </div>
            </template>
          <b-form-textarea
            id="out-of-office-textarea"
            v-model="outOfOfficeMessage"
            :disabled="generatingAudio || playingAudio"
            @input="audioStream = null"
            rows="3"
            required
          ></b-form-textarea>
          <div class="d-flex justify-content-end">
            
            <b-button v-if="!playingAudio && (!audioStream || !isLatestGeneratedText(outOfOfficeMessage))" :disabled="generatingAudio" size="sm" class="mt-1 mr-1" @click="generateTextToSpeech(outOfOfficeMessage)">
                <b-icon icon="volume-up"></b-icon> {{generatingAudio ? 'Generating Audio...' : 'Play Audio Preview'}}
            </b-button>
 
            <b-button v-else size="sm" :disabled="outOfOfficeMessageDisabled" class="mt-1 mr-1" @click="playStopAudioStream('outOfOfficeMessage')">
                <b-icon icon="volume-up"></b-icon> {{playingAudio ? 'Stop Audio' : 'Play Audio Preview'}}
            </b-button>

            <b-button 
                @click="defaultMessageConfirm('outOfOfficeMessage')" 
                :disabled="playingAudio"
                class="mt-1 mr-1" 
                size="sm">
            Use Default Message
            </b-button>

            <b-button variant="primary" 
                :disabled="dbMessages.outOfOfficeMessage == outOfOfficeMessage"
                @click="saveMessageConfirm('outOfOfficeMessage')"
                class="mt-1" 
                size="sm">{{ dbMessages.outOfOfficeMessage == outOfOfficeMessage ? 'Saved' : 'Save' }}</b-button>
          </div>
        </b-form-group>
  </div>
</template>

<script>

import { 
updateVoicemailVariable, 
//createVoicemailVariable, 
} from '@/graphql/mutations';

import { listVoicemailVariables} from '@/graphql/queries';
import { API } from 'aws-amplify';
import { onUpdateVoicemailVariable } from '@/graphql/subscriptions';
import { Predictions } from 'aws-amplify';
import {Howl} from 'howler';


const busyMessageKey = 'busyMessage';
const outOfOfficeMessageKey = 'outOfOfficeMessage';
const defaultBusyMessage = 'Sorry, the party you are trying to reach is not available now, please leave us a voice mail with your name and number, we will call you back as soon as possible.';
const defaultOutOfOfficeMessage = 'Sorry our office is now closed, please leave us a voice mail with your name and number, we will call you back as soon as possible.';



export default {
    name: 'Messages',
    computed: {
        busyMessageDisabled(){
            return this.busyMessage && !this.busyMessage.trim()
        },
        outOfOfficeMessageDisabled(){
            return this.outOfOfficeMessage && !this.outOfOfficeMessage.trim()
        },
        bp() {
            return this.$store.state.currentBreakpoint;
        },
        playingAudio(){
            if (!this.audioStream)
                return false;

            return this.audioStream.playing();
        },
        playButtonText(){
            return this.audioStream.playing() ? 'Stop' : 'Play'
        },
    },
    data() {
        return {
            busyMessage: null,
            outOfOfficeMessage: null,
            audioStream: null,
            generatingAudio: false,
            lastGeneratedText: null,
            dbMessages: {
                busyMessage: null,
                outOfOfficeMessage: null
            }
        }
    },
    watch: {
        busyMessage() {
            this.unsavedChangesCheck();
        },
        outOfOfficeMessage() {
            this.unsavedChangesCheck();
        },
    },
    async created(){
        //await this.createVoicemailVariable();
        await this.getVoicemailVariable();
        await this.subscribe();
    },
    beforeDestroy(){
        this.stopAudio();
    },
    props: {
        base64ArrayBuffer: Function
    },
    methods: {
        /*async createVoicemailVariable(){
        try {
            let prepared = {
                id: 'busyMessage',
                message: 'Inserted Now'
            }
            await API.graphql({
                query: createVoicemailVariable,
                variables: {
                    input: prepared,
                },
            });

            prepared = {
                id: 'outOfOfficeMessage',
                message: 'Inserted Now 2'
            }
            await API.graphql({
                query: createVoicemailVariable,
                variables: {
                    input: prepared,
                },
            });
        } catch (e) {
            console.log(e)
        }
    },*/
    unsavedChangesCheck(){
        let unsavedChanges = 
            this.dbMessages.busyMessage != this.busyMessage || 
            this.dbMessages.outOfOfficeMessage != this.outOfOfficeMessage;
        this.$root.unsavedChanges = unsavedChanges;
    },
    saveMessageConfirm(variable){
        let oldMessage = this.dbMessages[variable];
        let newMessage = this[variable];

        this.$root.confirm({
            message: `Are you sure you want to change this message from "${oldMessage}" to "${newMessage}"?`,
            title: 'Confirm',
            size: 'md',
            okTitle: 'Confirm',
            cancelTitle: 'Cancel'
        }, () => this.saveMessage(variable, newMessage));
    },
    async saveMessage(id, message) {
        this.savingMessage = true;
        let prepared = {
            id,
            message
        }
        try {
            await API.graphql({
                query: updateVoicemailVariable,
                variables: {
                    input: prepared,
                },
            });
            this.$bvToast.toast('Mesage has been saved successfully!', {
                title: `Success`,
                variant: 'primary',
                solid: true
            });
            this.savingMessage = false;
        } catch(error) {
            this.$bvToast.toast('Error: ' + JSON.stringify(error), {
                title: `Error saving message`,
                variant: 'danger',
                solid: true
            });
            this.savingVMessage = false;
        }
    },
    isLatestGeneratedText(message) {
        return message == this.latestGeneratedText;
    },
    defaultMessageConfirm(target){
        const message = !this[target] ? `Are you sure you want to use the default message?` : `Are you sure you want to overwrite the current message to the default message?`;

        this.$root.confirm({
            message,
            title: `Confirm to use default message`,
            okVariant: 'primary',
            okTitle: 'Confirm',
            cancelTitle: 'Cancel'
        }, 
            () => this.defaultingVoicemailMessage(target)
        )
    },
    defaultingVoicemailMessage(target) {
        let message = '';

        switch (target) {
            case busyMessageKey:
                message = defaultBusyMessage
                break;
            case outOfOfficeMessageKey:
                message = defaultOutOfOfficeMessage
                break;
        }

        this[target] = message;
    },
    playStopAudioStream(){
        this.audioStream.playing() ? this.audioStream.stop() : this.audioStream.play();
    },
    generateTextToSpeech(text) {
        this.generatingAudio = true;
        this.lastGeneratedText = text;
        Predictions.convert({
        textToSpeech: {
            source: {
                text: text,
            },
            voiceId: "Joanna" // default configured on aws-exports.js 
            // list of different options are here https://docs.aws.amazon.com/polly/latest/dg/voicelist.html
        }
        }).then(result => {
            
            this.generatingAudio = false;
            this.audioStream = new Howl({
                src: ["data:audio/mp3;base64,"+this.base64ArrayBuffer(result.audioStream)],
            });

            this.audioStream.play();
        
        })
        .catch(err => alert(err))
    },
    stopAudio(){
        if (this.audioStream && this.audioStream.playing()) {
            this.audioStream.stop();
        }
        this.audioStream = null;
    },
     async getVoicemailVariable() {
        const voicemailVariable = await API.graphql({
                query: listVoicemailVariables
            });
            const messagesList = voicemailVariable.data.listVoicemailVariables.items;

            this.busyMessage = messagesList.find(m => m.id == busyMessageKey).message;
            this.dbMessages.busyMessage = this.busyMessage;

            this.outOfOfficeMessage = messagesList.find(m => m.id == outOfOfficeMessageKey).message;
            this.dbMessages.outOfOfficeMessage = this.outOfOfficeMessage;

        },
        async subscribe() {
            API.graphql({ query: onUpdateVoicemailVariable })
                .subscribe({
                    next: (eventData) => {
                        let record = eventData.value.data.onUpdateVoicemailVariable;
                        this.dbMessages[record.id] = this[record.id] = record.message;
                        this.unsavedChangesCheck();
                    }
                });
        },
        async test(){
            let prepared = {
                id: 'busyMessage',
                message: 'This is from before'
            }
            try {
                await API.graphql({
                    query: updateVoicemailVariable,
                    variables: {
                        input: prepared,
                    },
                });
                this.$bvToast.toast('Holiday record has been edited successfully!', {
                    title: `Success`,
                    variant: 'primary',
                    solid: true
                });
            } catch(error) {
                console.log(error)
                this.$bvToast.toast('Error: ' + JSON.stringify(error), {
                    title: `Error editing record`,
                    variant: 'danger',
                    solid: true
                });
            }
        }
    }

}
</script>

<style>

</style>